<template>
  <b-modal
    ref="modalDocs"
    centered
    :title="$t('attachments.create-docx')"
  >
    <b-overlay
      :show="isLoading"
      variant="primary"
      opacity="0.3"
    >
      <b-form>
        <b-row>
          <b-col
            cols="12"
            lg="12"
          >
            <b-form-group
              :label="$t('attachments.templates')"
              label-for="template-name"
            >
              <div class="d-flex align-items-center justify-content-end">
                <v-select
                  v-model="filteringData.template"
                  class="w-100"
                  :options="templateOptions"
                  :placeholder="$t('attachments.filter-templates')"
                />
              </div>
            </b-form-group>
          </b-col>
          <!-- Field: Rename FileName -->
          <b-col
            cols="12"
            md="12"
          >
            <b-form-group
              :label="$t('attachments.filename')"
              label-for="rename-filename"
            >
              <b-form-input
                id="rename-filename"
                v-model="renameFilename"
              />
            </b-form-group>
          </b-col>
          <!-- Field: Custom Properties -->
          <b-col
            v-for="(prop, index) in customProps"
            :key="index"
            cols="12"
            md="12"
          >
            <b-form-group
              :label="prop.text + (!prop.nullable ? ' *' : ' (opz.)')"
              class="mb-1"
            >
              <b-form-input
                v-model="prop.value"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="mt-2"
          >
            <b-form-checkbox
              v-model="filteringData.pdfFormat"
              disabled
            >
              {{ $t('attachments.format-pdf') }}
            </b-form-checkbox>
          </b-col>
          <b-col
            cols="12"
            md="12"
          >
            <b-form-checkbox
              v-model="filteringData.saveAttachments"
            >
              {{ $t('attachments.save-attachments') }}
            </b-form-checkbox>
          </b-col>
        </b-row></b-form>
    </b-overlay>
    <template #modal-footer>
      <div class="w-100">
        <b-button-group
          class="float-right"
        >
          <b-button
            variant="outline-primary"
            @click="cancel"
          >
            {{ $t('common.cancel') }}
          </b-button>
          <b-button
            variant="outline-primary"
            :disabled="!isValidate"
            @click="ok"
          >
            {{ $t('common.export') }}
          </b-button>
        </b-button-group>
      </div>
    </template>
  </b-modal>
</template>

<script>
/* eslint-disable no-param-reassign */
import {
  BRow, BCol, BForm, BModal, BFormCheckbox, BButton, BButtonGroup, BFormGroup, BFormInput, BOverlay,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import axios from '@axios'
import authService from '@/vue.auth.service'
import {
  download, decode, toastErrorOptions, formatDate,
} from '@/views/layouts/layouts.utils'

export default {
  components: {
    BRow, BCol, BForm, BModal, BFormCheckbox, BButton, BButtonGroup, BFormGroup, BFormInput, vSelect, BOverlay,
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    refaid: {
      required: true,
    },
    table: {
      required: true,
      type: String,
      default: null,
    },
    rename: {
      required: false,
      type: String,
      default: null,
    },
    templates: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      templateOptions: [],
      filteringData: {},
      renameFilename: null,
      customProps: [],
      callback: null,
      isLoading: false,
    }
  },
  computed: {
    isValidate() {
      const hasAllPropsFilled = this.customProps && !this.customProps.find(p => !p.nullable && !p.value)
      return this.filteringData.template && this.filteringData.template !== null && hasAllPropsFilled
    },
  },
  async mounted() {
    this.$watch('filteringData.template', async () => {
      if (this.filteringData.template && this.filteringData.template !== null) {
        this.renameFilename = `${this.filteringData.template.label} - ${this.rename}`
        this.customProps = []
        const customText = this.filteringData.template.customProps
        if (customText) {
          customText.split('\n').forEach(item => {
            const splits = item.split('#').map(s => s.trim())
            const p = {
              text: splits[0],
              key: splits[1].replace(/\*$/, ''),
              nullable: !splits[1].endsWith('*'),
              pattern: splits.length >= 3 ? splits[2].split('@')[0].trim() : null,
              lastValue: splits.length >= 3 && splits[2].split('@').length > 1 ? parseInt(splits[2].split('@')[1].trim(), 10) + 1 : null,
              value: null,
            }
            if (p.pattern !== null) {
              p.value = p.pattern
              if (p.lastValue !== null) p.value = p.value.replace(/\{0\}/, p.lastValue)
              p.value = p.value.replace(/\{now\}/, formatDate(new Date(), 'DD/MM/yyyy'))
              p.value = p.value.replace(/\{year\}/, formatDate(new Date(), 'yyyy'))
            }
            this.customProps.push(p)
          })
        }
      } else {
        this.renameFilename = ''
        this.customProps = []
      }
    })
  },
  methods: {
    ok() {
      const request = {
        aid: this.refaid,
        filters: this.filteringData,
        renameFilename: this.renameFilename,
        customProps: this.customProps,
      }
      this.isLoading = true
      axios.post(`/api/docx/${this.table}`, request, { responseType: 'arraybuffer' })
        .then(async response => {
          if (this.customProps.find(p => p.lastValue !== null)) {
            const area = await authService.currentArea()
            const { settings } = area
            const T = settings.templates.find(t => t.uuid === this.filteringData.template.uuid)
            T.customProps = this.customProps.map(p => `${p.text}  #  ${p.key}${p.nullable ? '' : '*'}${p.pattern !== null ? `  #  ${p.pattern}${p.lastValue !== null ? `  @${p.lastValue}` : ''}` : ''}`).join('\n')
            await authService.saveSettings(area.aid, settings)
          }

          if (this.filteringData.saveAttachments === true && this.callback) {
            this.callback()
          } else download(response)
          this.cancel()
        })
        .catch(error => {
          this.isLoading = false
          const message = toastErrorOptions
          if (error.response) message.props.text = decode(error.response.data)
          this.$toast(message, { position: 'top-center' })
        })
    },
    cancel() {
      this.$refs.modalDocs.hide()
    },
    show(options, callback) {
      this.callback = callback
      this.isLoading = false
      this.templateOptions = []
      if (this.templates) {
        this.templateOptions = this.templates.filter(t => t.category === this.table)
      }
      this.filteringData = {
        pdfFormat: false,
        saveAttachments: false,
        options,
      }
      if (this.templateOptions && this.templateOptions.length === 1) {
        // eslint-disable-next-line prefer-destructuring
        this.filteringData.template = this.templateOptions[0]
      }

      this.$refs.modalDocs.show()
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
